module.exports = __webpack_public_path__ + "static/img/Visualization22.ba02fca9.png";